import React, {useEffect, useRef, useState} from 'react';
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {UsePermissions} from "../../../hooks/usePermissions";
import {Toast} from 'primereact/toast';
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {getData} from "../../../api/cliente.service";
import {Dropdown} from "primereact/dropdown";
import {exportExcel} from "../../../shared/utils/utils";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

export const TableCliente = ({obtenerParametrosUser, nuevoUsuario, reload}) => {
    console.log(obtenerParametrosUser);

    const [permisos] = UsePermissions()
    // parametros de la tabla
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowInit, setrowInit] = useState(10);
    const [cliente, setCliente] = useState([]);

    const toast = useRef(null);

    // payload al backend

    const initParams = {
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            'nombre': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'nit': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'direccion': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'telefono': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'tipo_facturacion': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
            'estado': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
            'centro_costo': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
        }
    };

    const [lazyParams, setLazyParams] = useState(initParams);

    const loadLazyData = () => {
        setLoading(true);
        init({lazyEvent: lazyParams}).then(data => {
            // record
            setTotalRecords(data.total);
            // total
            setCliente(data.record);
            setLoading(false);
        })
    }

    async function init(datos) {
        const response = await getData(datos);
        const data = await response.data;
        return data.data;
    }

    const onPage = (event) => {
        setrowInit(event.rows);
        setLazyParams(event);
    }
    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const laziParamsInit = () => {
        setLazyParams(initParams);
    }
    useEffect(() => {
        loadLazyData();
        return () => {
            // record
            setTotalRecords(0);
            // total
            setCliente([]);
        }
    }, [lazyParams])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (reload) {
            loadLazyData();
        }
        return () => {

        }
    }, [reload]);

    const facturacion = [
        {
            name: "Eventos",
            value: "E"
        },
        {
            name: "Hora",
            value: "H"
        }
    ];

    const statuses = [
        {
            name: "Activo",
            value: "A"
        },
        {
            name: "Inactivo",
            value: "I"
        }
    ];



    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option.value}`}>{option.name}</span>;
    }

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={statuses}
                         onChange={(e) => options.filterCallback(e.value, options.index)}
                         optionLabel="name"
                         itemTemplate={statusItemTemplate}
                         placeholder="Seleccione un estado" className="p-column-filter"
                         showClear/>;
    }

    const facturacionItemTemplate = (option) => {
        return <span className={`customer-badge status-${option.value}`}>{option.name}</span>;
    }

    const facturacionFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={facturacion}
                         onChange={(e) => options.filterCallback(e.value, options.index)}
                         optionLabel="name"
                         itemTemplate={facturacionItemTemplate}
                         placeholder="Seleccione un tipo de facturacion" className="p-column-filter"
                         showClear/>;
    }


    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevoUsuario}
                >
                    <i className="fa fa-user"/>
                </button>
            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={loadLazyData}
                >
                    <i className="fa fa-search"/>
                </button>

                <button
                    onClick={laziParamsInit}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-filter"/>
                </button>
                <button
                    onClick={() => exportExcel(cliente, "cliente")}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-print"/>
                </button>
            </div>

        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametrosUser(rowData)}>
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }
    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>
            <ContainerTable>
                <DataTable
                    showGridlines
                    header={header}
                    resizableColumns
                    columnResizeMode="expand"

                    size="small"
                    value={cliente}
                    lazy
                    filterDisplay="menu"
                    first={lazyParams.first}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    onSort={onSort}
                    sortField={lazyParams.sortField}
                    sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter}
                    filters={lazyParams.filters}
                    loading={loading}
                    paginator
                    rows={rowInit}
                    scrollable scrollHeight="500px"
                    rowsPerPageOptions={[50, 100, 300, 500]}

                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
                    responsiveLayout="scroll">
                    <Column header="Editar" style={{fontSize: ".8em"}} body={actionTemplate}></Column>

                    <Column field="nombre" header="Nombre" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="nit" header="Nit" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="direccion" header="Dirección" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="telefono" header="Telefono" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="tipo_facturacion" header="Tipo facturación" sortable filter showFilterMatchModes={false}
                            filterElement={facturacionFilterTemplate}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="estado" header="Estado" sortable filter
                            filterElement={statusFilterTemplate} showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="centro_costo" header="Centro de Costo" sortable filter
                            filterElement={statusFilterTemplate} showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                </DataTable>
            </ContainerTable>
        </>
    );
};


